/**
 * calculator-fotovoltaice.js
 *
 * Interfața interactivă. NU conține formule, doar controale și randare.
 * Toate calculele vin din PVModel (assets/pv-model.js), care e sursa de adevăr.
 *
 * Principiu: tabelul randat server-side NU se dublează. JS îl actualizează
 * pe loc, prin ancorele data-pvc-*. Așa nu există două variante de conținut,
 * iar ce vede motorul de căutare e exact ce vede omul.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pvc-app]');
  if (!root || !window.PVModel || !window.PVDate) return;

  var M = window.PVModel;
  var D = window.PVDate;

  var nf0 = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 });
  var nf1 = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  var nf2 = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function lei(v) { return nf0.format(Math.round(v)) + ' lei'; }
  function ani(v) { return v === null ? 'nu se amortizează' : v + (v === 1 ? ' an' : ' ani'); }

  var state = {};
  for (var k in D.DEFAULTS) {
    if (Object.prototype.hasOwnProperty.call(D.DEFAULTS, k)) state[k] = D.DEFAULTS[k];
  }

  /* ---------- definiția controalelor ---------- */

  var GRUPE = [
    {
      titlu: 'Ipotezele tale',
      campuri: [
        { tip: 'select-profil' },
        { key: 'consumAnual', et: 'Consum anual', unit: 'kWh', min: 500, max: 30000, step: 100 },
        { tip: 'select-zona' },
        { key: 'pretAllIn', et: 'Preț plătit pe factură', unit: 'lei/kWh', min: 0.5, max: 3, step: 0.01,
          ajutor: 'Prețul întreg, cu rețea, taxe și TVA. Media reală în România este în jur de 1,45 lei/kWh.' },
        { key: 'componentaEnergie', et: 'Componenta de energie din contract', unit: 'lei/kWh', min: 0.1, max: 1.5, step: 0.01,
          ajutor: 'ATENȚIE, câmpul care decide totul. Energia injectată se compensează DOAR la această valoare, nu la prețul întreg. Verifică-l pe factură. Interval real în iulie 2026: 0,45 la Hidroelectrica, până la 1,03 la Engie Serviciu Universal.' },
        { key: 'cresterePret', et: 'Creștere anuală a prețului energiei', unit: '%/an', min: 0, max: 15, step: 0.5,
          ajutor: 'Ipoteză, nu prognoză. Rezultatul e foarte sensibil la ea.' },
        { key: 'rataActualizare', et: 'Rată de actualizare', unit: '%', min: 0, max: 15, step: 0.5,
          ajutor: 'Costul de oportunitate al banilor. Dacă i-ai fi ținut altundeva, ce randament ar fi adus.' },
        { key: 'orizont', et: 'Orizont de analiză', unit: 'ani', min: 5, max: 30, step: 1 }
      ]
    },
    {
      titlu: 'Sistemul fotovoltaic',
      campuri: [
        { key: 'kWp', et: 'Putere instalată', unit: 'kWp', min: 1, max: 30, step: 0.5 },
        { key: 'costSistemPV', et: 'Cost sistem montat, fără baterie', unit: 'lei', min: 0, max: 200000, step: 500,
          ajutor: 'Cere 2 sau 3 oferte reale. Este cifra la care rezultatul e cel mai sensibil.' },
        { key: 'productieSpecifica', et: 'Producție specifică', unit: 'kWh/kWp/an', min: 800, max: 1600, step: 10,
          ajutor: 'Verifică pentru zona și orientarea ta în PVGIS, instrumentul Comisiei Europene.' },
        { key: 'autoconsumFaraBaterie', et: 'Autoconsum fără baterie', unit: '%', min: 5, max: 100, step: 1,
          ajutor: 'Cât din producție consumi pe loc. Tipic 25 până la 40% pentru o gospodărie.' },
        { key: 'subventie', et: 'Subvenție', unit: 'lei', min: 0, max: 60000, step: 500,
          ajutor: 'Casa Verde Fotovoltaice nu este finanțată în 2026. Pentru baterii există fonduri alocate, dar ghidul nu e publicat și valoarea pe beneficiar nu e oficial cunoscută.' },
        { key: 'mentenantaAnuala', et: 'Mentenanță', unit: 'lei/an', min: 0, max: 5000, step: 50 }
      ]
    },
    {
      titlu: 'Bateria',
      campuri: [
        { key: 'capacitateBaterie', et: 'Capacitate utilă', unit: 'kWh', min: 0, max: 100, step: 1 },
        { key: 'costBaterie', et: 'Cost baterie montată', unit: 'lei', min: 0, max: 200000, step: 500,
          ajutor: 'Iulie 2026, doar bateria: 10 kWh între 8.000 lei gamă buget și 25.000 lei premium.' },
        { key: 'autoconsumCuBaterie', et: 'Autoconsum cu baterie', unit: '%', min: 5, max: 100, step: 1,
          ajutor: 'Tipic 60 până la 80%. Diferența față de varianta fără baterie este tot beneficiul bateriei.' },
        { key: 'anInlocuireBaterie', et: 'An înlocuire baterie', unit: 'an', min: 5, max: 30, step: 1 },
        { key: 'spreadCaptabil', et: 'Spread captabil pe arbitraj', unit: 'lei/kWh', min: 0, max: 1.5, step: 0.01,
          ajutor: 'Doar pentru tarif indexat la bursă. Spread-ul mare dintre amiază și seară este pe piața wholesale, pe retail se captează mult mai puțin. Fără contor inteligent cu citire pe 15 minute, nu captezi nimic.' },
        { key: 'venitVPPAnual', et: 'Venit din VPP', unit: 'lei/an', min: 0, max: 20000, step: 100,
          ajutor: 'Implicit 0, intenționat. Nu există nicio estimare independentă pe gospodărie în România. Folosește pragul calculat mai jos ca să judeci orice ofertă.' }
      ]
    }
  ];

  /* ---------- construirea controalelor ---------- */

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  var inputs = {};

  function campNumeric(c) {
    var wrap = el('div', 'pvc-field');
    var lab = el('label', 'pvc-label');
    lab.setAttribute('for', 'pvc-' + c.key);
    lab.appendChild(el('span', 'pvc-label-text', c.et));
    if (c.unit) lab.appendChild(el('span', 'pvc-unit', c.unit));
    if (c.ajutor) {
      var h = el('button', 'pvc-help', '?');
      h.type = 'button';
      h.setAttribute('aria-label', 'Explicație pentru ' + c.et);
      h.title = c.ajutor;
      h.addEventListener('click', function () {
        var nota = wrap.querySelector('.pvc-help-text');
        if (nota) { nota.remove(); return; }
        var n = el('p', 'pvc-help-text', c.ajutor);
        wrap.appendChild(n);
      });
      lab.appendChild(h);
    }
    wrap.appendChild(lab);

    var inp = document.createElement('input');
    inp.type = 'number';
    inp.className = 'pvc-input';
    inp.id = 'pvc-' + c.key;
    inp.value = state[c.key];
    if (c.min != null) inp.min = c.min;
    if (c.max != null) inp.max = c.max;
    if (c.step != null) inp.step = c.step;
    inp.addEventListener('input', function () {
      var v = parseFloat(inp.value);
      if (isNaN(v)) return;
      state[c.key] = v;
      randeaza();
    });
    inputs[c.key] = inp;
    wrap.appendChild(inp);
    return wrap;
  }

  function campSelectProfil() {
    var wrap = el('div', 'pvc-field');
    var lab = el('label', 'pvc-label');
    lab.setAttribute('for', 'pvc-profil');
    lab.appendChild(el('span', 'pvc-label-text', 'Profil rapid'));
    wrap.appendChild(lab);
    var sel = document.createElement('select');
    sel.className = 'pvc-input';
    sel.id = 'pvc-profil';
    D.PROFILURI.forEach(function (pr) {
      var o = document.createElement('option');
      o.value = pr.id;
      o.textContent = pr.nume + ' (' + nf0.format(pr.consumAnual) + ' kWh/an)';
      if (pr.consumAnual === state.consumAnual) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      var pr = D.PROFILURI.filter(function (x) { return x.id === sel.value; })[0];
      if (!pr) return;
      state.consumAnual = pr.consumAnual;
      if (inputs.consumAnual) inputs.consumAnual.value = pr.consumAnual;
      randeaza();
    });
    wrap.appendChild(sel);
    return wrap;
  }

  function campSelectZona() {
    var wrap = el('div', 'pvc-field');
    var lab = el('label', 'pvc-label');
    lab.setAttribute('for', 'pvc-zona');
    lab.appendChild(el('span', 'pvc-label-text', 'Zona de distribuție'));
    var h = el('button', 'pvc-help', '?');
    h.type = 'button';
    h.title = 'Tariful de distribuție diferă pe zone și s-a schimbat la 1 iulie 2026, nu în aceeași direcție peste tot.';
    h.setAttribute('aria-label', 'Explicație pentru zona de distribuție');
    h.addEventListener('click', function () {
      var nota = wrap.querySelector('.pvc-help-text');
      if (nota) { nota.remove(); return; }
      wrap.appendChild(el('p', 'pvc-help-text', h.title));
    });
    lab.appendChild(h);
    wrap.appendChild(lab);

    var sel = document.createElement('select');
    sel.className = 'pvc-input';
    sel.id = 'pvc-zona';
    D.ZONE.forEach(function (z) {
      var o = document.createElement('option');
      o.value = z.id;
      o.textContent = z.nume;
      if (Math.abs(z.distributieJT - state.distributieJT) < 1e-9) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      var z = D.ZONE.filter(function (x) { return x.id === sel.value; })[0];
      if (!z) return;
      state.distributieJT = z.distributieJT;
      randeaza();
    });
    wrap.appendChild(sel);
    return wrap;
  }

  function construiesteControale() {
    var gazda = root.querySelector('[data-pvc-controls]');
    if (!gazda) return;
    gazda.innerHTML = '';

    GRUPE.forEach(function (g) {
      var fs = el('fieldset', 'pvc-grup');
      fs.appendChild(el('legend', 'pvc-grup-titlu', g.titlu));
      var grid = el('div', 'pvc-grid');
      g.campuri.forEach(function (c) {
        if (c.tip === 'select-profil') grid.appendChild(campSelectProfil());
        else if (c.tip === 'select-zona') grid.appendChild(campSelectZona());
        else grid.appendChild(campNumeric(c));
      });
      fs.appendChild(grid);
      gazda.appendChild(fs);
    });

    var actiuni = el('div', 'pvc-actiuni');
    var reset = el('button', 'pvc-reset', 'Revino la valorile implicite');
    reset.type = 'button';
    reset.addEventListener('click', function () {
      for (var kk in D.DEFAULTS) {
        if (Object.prototype.hasOwnProperty.call(D.DEFAULTS, kk)) state[kk] = D.DEFAULTS[kk];
      }
      construiesteControale();
      randeaza();
    });
    actiuni.appendChild(reset);
    gazda.appendChild(actiuni);
  }

  /* ---------- randarea rezultatelor, în ancorele SSR ---------- */

  function randeaza() {
    var rez = M.ruleazaTot(state);
    var raport = M.raportAutoconsumInjectie(state);
    var referinta = rez.filter(function (r) { return r.id === 'fara'; })[0];
    var scBat = rez.filter(function (r) { return r.id === 'pv_bat'; })[0];
    var scPZU = rez.filter(function (r) { return r.id === 'pv_bat_pzu'; })[0];

    var tbody = document.querySelector('[data-pvc-tbody]');
    if (tbody) {
      tbody.innerHTML = '';
      rez.forEach(function (r) {
        var esteRef = r.id === 'fara';
        var tr = el('tr');
        if (esteRef) tr.className = 'pvc-ssr-ref';
        var th = el('th', null, r.nume);
        th.setAttribute('scope', 'row');
        tr.appendChild(th);
        var marg = r.marginal
          ? ani(r.marginal.aniActualizat) + ' pentru bateria de ' + lei(r.marginal.capexSuplimentar)
          : (r.id === 'pv' ? 'nu are baterie' : 'referință');
        [
          esteRef ? '0 lei' : lei(r.capex),
          esteRef ? 'referință' : ani(r.anAmortizare),
          esteRef ? 'referință' : ani(r.amortizareActualizata),
          esteRef ? '-' : marg,
          lei(r.facturaLunaraMedie),
          esteRef ? '-' : nf2.format(r.lcoe) + ' lei'
        ].forEach(function (v) { tr.appendChild(el('td', null, v)); });
        if (r.id !== 'fara' && r.anAmortizare !== null) {
          var minim = Math.min.apply(null, rez.filter(function (x) {
            return x.id !== 'fara' && x.amortizareActualizata !== null;
          }).map(function (x) { return x.amortizareActualizata; }));
          if (r.amortizareActualizata === minim) tr.classList.add('pvc-best');
        }
        tbody.appendChild(tr);
      });
    }

    var cap = document.querySelector('[data-pvc-caption]');
    if (cap) {
      cap.textContent = 'Cost total de deținere pe ' + state.orizont +
        ' de ani, pentru o gospodărie cu ' + nf0.format(state.consumAnual) +
        ' kWh pe an și un sistem de ' + nf1.format(state.kWp) + ' kWp.';
    }

    var teza = document.querySelector('[data-pvc-teza]');
    if (teza) {
      teza.innerHTML = 'Cu valorile de mai sus, un kilowatt-oră consumat direct din panouri ' +
        'valorează <strong>' + nf1.format(raport) + ' ori mai mult</strong> decât unul injectat în rețea. ' +
        'Autoconsumul îți economisește prețul întreg de pe factură, ' + nf2.format(state.pretAllIn) +
        ' lei pe kWh. Energia injectată se compensează doar la componenta de energie activă, ' +
        nf2.format(state.componentaEnergie) + ' lei pe kWh. ' +
        'De aceea rata de autoconsum decide amortizarea, nu numărul de kilowați instalați.';
    }

    var marginal = document.querySelector('[data-pvc-marginal]');
    if (marginal && scBat && scBat.marginal && scPZU && scPZU.marginal) {
      marginal.innerHTML = 'Panourile și bateria sunt două decizii diferite. Întrebarea corectă este ' +
        'dacă cei ' + lei(state.costBaterie) + ' în plus se întorc singuri. Cu valorile de mai sus și un ' +
        'furnizor obișnuit, bateria aduce în plus <strong>' + lei(scBat.marginal.beneficiuSuplimentarAn1) +
        '</strong> în primul an și se amortizează în <strong>' + ani(scBat.marginal.aniActualizat) +
        '</strong>, în timp ce trebuie înlocuită în jurul anului ' + state.anInlocuireBaterie + '. ' +
        'Pe un tarif indexat la bursă, se amortizează în <strong>' + ani(scPZU.marginal.aniActualizat) +
        '</strong>, fiindcă poate muta exportul din golul de preț de la amiază spre vârful de seară.';
    }

    var pragEl = document.querySelector('[data-pvc-prag]');
    if (pragEl) {
      var prag = M.pragVenitVPP(state);
      pragEl.innerHTML = 'Nu există nicio estimare independentă, pe gospodărie, a câștigului real ' +
        'dintr-un VPP în România, deci nu presupunem niciun venit. Întoarcem întrebarea: ' +
        (prag === null
          ? 'la valorile de mai sus, bateria nu se amortizează în durata ei de viață nici cu venituri mari din servicii de rețea.'
          : 'bateria se amortizează în ' + state.anInlocuireBaterie + ' ani dacă serviciile de rețea îți aduc peste <strong>' +
            lei(prag) + ' pe an</strong>, adică aproximativ ' + lei(prag / 12) + ' pe lună.') +
        ' Aceasta este cifra cu care poți confrunta orice ofertă comercială.';
    }

    var facturaRef = document.querySelector('[data-pvc-referinta]');
    if (facturaRef && referinta) {
      facturaRef.textContent = lei(referinta.facturaLunaraMedie);
    }
  }

  /* ---------- verificare de paritate SSR vs JS ---------- */

  function verificaParitate() {
    var ssrTeza = document.querySelector('[data-pvc-teza]');
    if (!ssrTeza) return;
    var inainte = ssrTeza.textContent.replace(/\s+/g, ' ').trim();
    randeaza();
    var dupa = ssrTeza.textContent.replace(/\s+/g, ' ').trim();
    if (inainte !== dupa && window.console && console.warn) {
      console.warn(
        '[calculator-fotovoltaice] Tabelul server-side diferă de recalculul din browser. ' +
        'Rulează "node tools/build-ssr.mjs" și dă push, altfel HTML-ul indexat rămâne pe cifre vechi.'
      );
    }
  }

  construiesteControale();
  verificaParitate();
})();
